import { JobArea } from '__gql-generated__/types'
import { JOB_POSITIONS_OPTIONS } from 'components/edit-permissions-role-modal/constants'
import type { LanguageTokens } from 'i18n'

export const JOB_AREAS_OPTIONS: {
  label: LanguageTokens
  value: JobArea
  description: LanguageTokens
}[] = [
  {
    label: 'Linguagens e Comunicação' as LanguageTokens,
    value: JobArea.LanguagesAndCommunication,
    description: 'Língua Portuguesa, Literatura e Redação.' as LanguageTokens
  },
  {
    label: 'Tecnologia e Inovação' as LanguageTokens,
    value: JobArea.TechnologyAndInnovation,
    description: 'Robótica, Programação e TIC.' as LanguageTokens
  },
  {
    label: 'Expressões e Corpo' as LanguageTokens,
    value: JobArea.ExpressionsAndBody,
    description: 'Artes e Educação Física' as LanguageTokens
  },
  {
    label: 'Ciências humanas' as LanguageTokens,
    value: JobArea.HumanSciences,
    description:
      'História, Geografia, Filosofia, Sociologia, Estudos Sociais e Ensino Religioso.' as LanguageTokens
  },
  {
    label: 'Língua Estrangeira' as LanguageTokens,
    value: JobArea.ForeignLanguage,
    description:
      'Ensino de idiomas estrangeiros como Inglês, Espanhol, Francês, entre outros.' as LanguageTokens
  },
  {
    label: 'Desenvolvimento pessoal' as LanguageTokens,
    value: JobArea.PersonalDevelopment,
    description: 'Projeto de Vida e Socioemocional.' as LanguageTokens
  },
  {
    label: 'Matemática e suas tecnologias' as LanguageTokens,
    value: JobArea.MathematicsAndTechnologies,
    description: 'Matemática e Geometria.' as LanguageTokens
  },
  {
    label: 'Ciências da natureza' as LanguageTokens,
    value: JobArea.NaturalSciences,
    description: 'Física, Química, Biologia e Ciências.' as LanguageTokens
  }
]

export const enum JobOption {
  JOB_AREAS = 'JOB_AREAS',
  JOB_POSITIONS = 'JOB_POSITIONS'
}

export const JOB_OPTIONS = {
  [JobOption.JOB_AREAS]: JOB_AREAS_OPTIONS,
  [JobOption.JOB_POSITIONS]: JOB_POSITIONS_OPTIONS
}

export const TITLE_AND_SUBTITLE_BY_JOB_OPTION: Record<
  JobOption,
  {
    titleModal: LanguageTokens
    title: LanguageTokens
    subtitle: LanguageTokens
  }
> = {
  [JobOption.JOB_AREAS]: {
    titleModal: 'Editar área de atuação' as LanguageTokens,
    title:
      'Escolha a opção que melhor descreve sua área de atuação.' as LanguageTokens,
    subtitle:
      'Caso você atue em mais de uma área na escola, selecione todas os que se aplicam a você.' as LanguageTokens
  },
  [JobOption.JOB_POSITIONS]: {
    titleModal: 'Editar cargo' as LanguageTokens,
    title:
      'Escolha o cargo que mais se aproxima da sua atuação na escola para personalizarmos sua experiência na Árvore.' as LanguageTokens,
    subtitle:
      'Você pode marcar mais de um cargo, se for o caso.' as LanguageTokens
  }
}
